import React, { useState } from "react";
import "./ComplaintModal.css";
import close from "../../../Assets/close.svg";
import api from "../../../services/api";
import { useToast } from "../../../mesageToast/ToastContainer";

const ComplaintModal = ({ ticket, onClose, onUpdate }) => {
  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const addToast = useToast();
  const handleConfirm = async () => {
    if (!responseMessage.trim()) {
      addToast("Please enter a response message", "error");
      return;
    }

    setIsSubmitting(true);
    try {
      await api.post("/support/respond", {
        ticketId: ticket.ticketId,
        responseMessage: responseMessage.trim(),
      });

      onUpdate();
      onClose();
    } catch (error) {
      console.error("Error sending response:", error);
      // alert(error.response?.data?.message || "Failed to send response");
    } finally {
      setIsSubmitting(false);
    }
  };
  if (!ticket) return null;

  return (
    <div className="modal-overlay">
      <div className="complaint-modal">
        <button className="close-btn" onClick={onClose}>
          <img src={close} alt="close" />
        </button>
        <h3 className="complaint-title">Complaint</h3>
        <h2
          className="restaurant-name"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {/* {ticket.restaurant || "N/A"} */}
          <span className={`status-badge ${ticket.status.toLowerCase()}`}>
            {ticket.status}
          </span>
        </h2>
        <p className="requestor">
          <strong>Request by:</strong> {ticket.customerName || ticket.orderBy || "N/A"}
        </p>
        {/* <p className="order-cancel">
          <strong>Order ID:</strong> {ticket.orderId}
        </p> */}
        {/* <p className="order-type-status">
          <strong>Order Type:</strong> {ticket.orderType || "N/A"} |{" "}
          <strong>Order Status:</strong> {ticket.orderStatus || "N/A"}
        </p>
        {ticket.orderType === "Takeaway" && ticket.pickupTime && (
          <p className="pickup-time">
            <strong>Pickup Time:</strong> {ticket.pickupTime}
          </p>
        )} */}
        {/* {ticket.orderType === "Dine-in" && ticket.dineInTime && (
          <p className="dine-in-time">
            <strong>Dine-in Time:</strong> {ticket.dineInTime}
            {ticket.numberOfPeople && (
              <span>
                {" "}
                | <strong>People:</strong> {ticket.numberOfPeople}
              </span>
            )}
          </p>
        )} */}
        <p className="contact-info">
          <strong>Email:</strong> {ticket.email}
          <br />
          <strong>Phone:</strong> {ticket.phone || "N/A"}
        </p>

        {ticket.items && ticket.items.length > 0 && (
          <div className="order-items">
            <h4 style={{ margin: "0" }}>Order Items:</h4>
            {ticket.items.map((item, index) => (
              <div key={index} className="item">
                <div style={{ width: "300px" }}>{item.name}</div>
                <div>{item.quantity}</div>
                <div>₹{item.price}</div>
              </div>
            ))}
            <div className="total-amount">
              <strong>Total Amount:</strong>₹{ticket.price}
            </div>
          </div>
        )}

        {ticket.aiSummary && (
          <div className="customer-message">
            <strong>AI Summary:</strong>
            <p>{ticket.aiSummary}</p>
          </div>
        )}

        <div className="customer-message">
          <strong>Customer Messages:</strong>
          {ticket.messages && ticket.messages.length > 0 ? (
            ticket.messages.map((msg, index) => (
              <div key={index} className="message-item">
                <p>
                  <strong>
                    {msg.userName} (
                    {msg.userType === "support team"
                      ? "Support Team"
                      : msg.userType}
                    ):
                  </strong>{" "}
                  {msg.content}
                </p>
                <small>{new Date(msg.timestamp).toLocaleString()}</small>
              </div>
            ))
          ) : (
            <p>No messages available</p>
          )}
        </div>

        {ticket.selectitem && ticket.selectitem.length > 0 && (
          <p className="category">
            <strong>Selected Items:</strong>{" "}
            {ticket.selectitem.map((item) => item.name).join(", ")}
          </p>
        )}

        {ticket.status.toLowerCase() !== "resolved" && (
          <>
            {/* <textarea
              className="message-box"
              placeholder="Enter your response message..."
              value={responseMessage}
              onChange={(e) => setResponseMessage(e.target.value)}
            />

            <button
              className="complaint-confirm-btn"
              onClick={handleConfirm}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send Response"}
            </button> */}
          </>
        )}
      </div>
    </div>
  );
};

export default ComplaintModal;
